class Modal {
  constructor(selector, options = {}) {
    this.selector = selector
    this.openSelector = options.openSelector || null

    this.onOpenClick = this.onOpenClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onOverlayClick = this.onOverlayClick.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
  }

  initState() {
    this.modal = document.querySelector(this.selector)

    if (!this.modal) {
      return false
    }

    this.overlay = this.modal.querySelector('.modal__overlay')
    this.closeBtn = this.modal.querySelector('.modal__close-btn')
    this.closeBtns = this.modal.querySelectorAll('.js-close-modal')
    this.openBtns = this.openSelector
      ? document.querySelectorAll(this.openSelector)
      : []

    this.duration = parseFloat(getComputedStyle(this.modal).transitionDuration) * 1000
    this.isOpen = false

    return true
  }

  render() {
    if (this.isOpen) {
      this.scrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollY}px`
      document.body.style.left = '0'
      document.body.style.right = '0'
      this.modal.classList.add('modal--active')
    } else {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      window.scrollTo(0, this.scrollY)
      this.modal.classList.remove('modal--active')
    }
  }

  open() {
    this.isOpen = true
    this.render()
  }

  close() {
    this.isOpen = false
    this.render()
  }

  onOpenClick(e) {
    e.preventDefault()
    this.open()
  }

  onCloseClick() {
    this.close()
  }

  onOverlayClick() {
    this.close()
  }

  onKeyDown(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.close()
    }
  }

  init() {
    if (!this.initState()) {
      return
    }

    this.openBtns.forEach((btn) => {
      btn.addEventListener('click', this.onOpenClick)
    })
    this.closeBtn && this.closeBtn.addEventListener('click', this.onCloseClick)
    this.closeBtns.forEach((btn) => {
      btn.addEventListener('click', this.onCloseClick)
    })
    this.overlay && this.overlay.addEventListener('click', this.onOverlayClick)
    document.addEventListener('keydown', this.onKeyDown)
  }

  destroy() {
    this.openBtns.forEach((btn) => {
      btn.removeEventListener('click', this.onOpenClick)
    })
    this.closeBtn && this.closeBtn.removeEventListener('click', this.onCloseClick)
    this.closeBtns.forEach((btn) => {
      btn.removeEventListener('click', this.onCloseClick)
    })
    this.overlay && this.overlay.removeEventListener('click', this.onOverlayClick)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  static initAnchors() {
    const modals = document.querySelectorAll('.modal[id]')
    const modalInstances = new Map()

    modals.forEach((modalEl) => {
      const modalId = modalEl.id
      const modal = new Modal(`#${modalId}`)
      modal.init()
      modalInstances.set(modalId, modal)
    })

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]')
      if (!link) return

      const href = link.getAttribute('href')
      const modalId = href.slice(1)

      if (modalInstances.has(modalId)) {
        e.preventDefault()
        modalInstances.get(modalId).open()
      }
    })

    return modalInstances
  }
}

export default Modal
